// Event Names
export const G2W_ANALYTICS_DASHBOARD = 'G2W Analytics Dashboard';
export const G2W_ADMIN_ANALYTICS_DASHBOARD = 'G2W Admin Analytics Dashboard';
export const G2W_ANALYTICS_TYPE_SWITCHER = 'G2W Analytics Type Switcher';
export const G2W_ADMIN_ANALYTICS_SESSION_DETIALS = 'G2W Admin Analytics Session Details';
export const G2W_ANALYTICS_FEATURE = 'G2W Analytics Feature';
export const G2W_ADMIN_ANALYTICS_FEATURE = 'G2W Admin Analytics Feature';
export const G2W_ANALYTICS_REPORT_TYPE = 'G2W Analytics Report Type';
export const G2W_ANALYTICS_FILTER_TYPE = 'G2W Analytics Filter Type';
export const G2W_ADMIN_ANALYTICS_FILTER_TYPE = 'G2W Admin Analytics Filter Type';
export const G2W_ADMIN_ANALYTICS_ORGANIZER_FILTER = 'G2W Admin Analytics Organizer Filter';
export const G2W_ANALYTICS_GENERATE_REPORT_FEATURE = 'G2W Analytics Generate Report Feature';
export const G2W_ADMIN_ANALYTICS_GENERATE_REPORT_FEATURE = 'G2W Admin Analytics Generate Report Feature';
export const G2W_ADMIN_ANALYTICS_DOWNLOAD_REPORT = 'G2W Admin Analytics Download Report';
export const G2W_ANALYTICS_CHART_TYPE = 'G2W Analytics Chart Type';
export const G2W_ADMIN_ANALYTICS_CHART_TYPE = 'G2W Admin Analytics Chart Type';
export const G2W_ANALYTICS_EVENT = 'Analytics';
export const G2W_ADMIN_ANALYTICS_EVENT = 'Admin Analytics';
export const G2W_ANALYTICS_SEND_EMAIL_REPORT = 'G2W Analytics Send Email Report';

export const PROFILE_MENU = 'Profile Menu';
export const BACK_TO_OLD_VIEW = 'Back To Old View';
export const SEND_EMAIL_REPORT = 'Send Email Report';

// Properties
export const TYPE = 'Type';
export const SUB_TYPE = 'Sub Type';
export const FEATURE = 'Feature';
export const ACTION = 'Action';
export const FORMAT = 'Format';
export const MIN_VALUE = 'Min Value';
export const MAX_VALUE = 'Max Value';
export const VALUE = 'Value';
export const REPORT_TYPE = 'Report Type';
export const SESSION_KEY = 'Session Key';
export const SESSION_KEYS = 'Session Keys';

// Property values
export const LANDING_PAGE = 'Landing Page';

export const LIVE = 'Live';
export const RECORDING = 'Recording';

export const VALUE_ADD = 'Value Add';
export const AUTH = 'Auth';
export const DOWNLOADED = 'Downloaded';
export const VIEWED = 'Viewed';
export const DOWNLOAD = 'Download';
export const EMAIL = 'Email';

export class MixpanelChartType {
  static get SESSIONS_OVERVIEW_CHART() {
    return 'Sessions Overview Chart';
  }
  static get RECORDINGS_OVERVIEW_VIEWS_CHART() {
    return 'Recordings Overview Views Chart';
  }
  static get RECORDINGS_OVERVIEW_SHARES_CHART() {
    return 'Recordings Overview Shares Chart';
  }
  static get ATTENDANCE_CONVERSION_CHART() {
    return 'Attendance Conversion Chart';
  }
  static get ATTENDEES_IN_SESSION_CHART() {
    return 'Attendees In Session Chart';
  }
  static get RECORDING_DETAILS_G2W_CHART() {
    return 'Recording Details from G2W Chart';
  }
}

export class MixpanelReportType {
  static get SESSIONS_OVERVIEW_REPORT() {
    return 'Sessions Overview';
  }
  static get WEBINAR_REGISTRATION_REPORT() {
    return 'Registration Report';
  }
  static get WEBINAR_ATTENDEE_REPORT() {
    return 'Attendee Report';
  }
  static get WEBINAR_QANDA_REPORT() {
    return 'QAndA Followup Report';
  }
  static get WEBINAR_PERFORMANCE_REPORT() {
    return 'Performance Report';
  }
  static get WEBINAR_RECORDING_REPORT() {
    return 'Recording Report';
  }
  static get WEBINAR_SURVEY_REPORT() {
    return 'Survey Report';
  }
  static get SESSIONS_ATTENDANCE_REPORT() {
    return 'Multi-Session Attendee Report';
  }
  static get SESSIONS_QANDA_FOLLOW_UP_REPORT() {
    return 'Engagement Report';
  }
  static get RECORDING_VIEWS_REPORT() {
    return 'Recording Views Report';
  }
}

export class AnalyticsTypeSwitcher {
  static get LIVE() {
    return LIVE;
  }
  static get RECORDING() {
    return RECORDING;
  }
  static get SESSION_DETAILS() {
    return SESSION_DETAILS;
  }
  static get RECORDING_DETAILS() {
    return RECORDING_DETAILS;
  }
}

export const SESSIONS_OVERVIEW = 'Sessions Overview';
export const RECORDINGS_OVERVIEW = 'Recordings Overview';
export const WEBINARS_TABLE = 'Webinars Table';
export const SESSION_REGISTRANTS_TABLE = 'Session Registrants Table';
export const SESSION_ATTENDEES_TABLE = 'Session Attendees Table';
export const SESSION_DETAILS = 'Session Details';
export const RECORDING_DETAILS = 'Recording Details';
export const REGISTRANTS_SEARCH = 'Registrants Search';
export const QUESTIONS_SEARCH = 'Q And A Search';
export const POLLS_SEARCH = 'Polls Search';
export const SURVEY_SEARCH = 'Survey Search';
export const ATTENDEES_SEARCH = 'Attendees Search';
export const RECORDING_VIEW_SEARCH = 'Recording View Search';
// engagement
export const ENGAGEMENT_POLLS_TAB = 'Engagement Polls Tab';
export const ENGAGEMENT_SURVEY_TAB = 'Engagement Survey Tab';
export const ENGAGEMENT_QANDA_TAB = 'Engagement QAndA Tab';
export const VIEW_ENGAGEMENT_RESULTS = 'View Engagement Results';

// engagement details
export const ENGAGEMENT_DETAILS = 'Session Engagement Details';
// Q And A
export const PAGINATE_QANDA = 'Paginate Q And A';
export const SORT_QANDA = 'Sort Q And A';
export const FILTER_QANDA = 'Filter Q And A';

export const FILTER = 'Filter';
export const CALENDAR = 'Calendar';
export const TREND = 'Trend';
export const GENERATE_REPORT = 'Generate Report';
export const CHECKBOX = 'Checkbox Selection';
export const DOWNLOAD_CHART = 'Download Chart';
export const DOWNLOAD_VIEWS_CHART = 'Download Views Chart';
export const SEARCH = 'Search';
export const TIP_CLICKED = 'Tip Clicked';
export const LOGIN = 'Login';
export const LOGOUT = 'Logout';
export const ORGANIZER_COUNT = 'Organizer Count';

export const PDF = 'Pdf';
export const CSV = 'Csv';
export const EXCEL = 'Excel';
export const PNG = 'Png';

export const REGISTRANTS = 'Registrants';
export const ATTENDEES = 'Attendees';

export const VIEWS = 'Views';
export const SHARES = 'Shares';
export const RECORDING_SOURCE = 'Recording Source';

// Recording Details
export const RECORDING_VIEWS_CHART = 'Recording Views Chart';
export class RecordingSourceType {
  static get STANDALONE() {
    return 'Standalone Recording';
  }
  static get GOTOSTAGE() {
    return 'GoToStage Recording';
  }

  static get GOTOSTAGE_EMBEDDED() {
    return 'GoToStage Embedded Recording';
  }
}



// WEBPACK FOOTER //
// ./src/Telemetry/Mixpanel/Constants/mixpanelConstants.js